import React, { Component } from "react";
import 'react-responsive-modal/styles.css';
import { withTranslation } from 'react-i18next';
import axios from "axios";
import TokenService from "../../backend/TokenService";
import ErrorModal from "../../components/modal/ErrorModal";
import {Flex} from "../../styles/GlobalStyle";
import {get, isEmpty} from "lodash";
import {Avatar} from "@material-ui/core";
import moment from "moment";
import Link from "../../components/Link";
import Property from "../../model/property";
import {
  TitleName,
  TitleOrder,
  Detail,
  Container,
  Subtotal,
  Total,
  ProductOption,
  Status,
  StatusValue,
  Notes
} from "./style/SuccessStyle.js";
import LocalGroceryStoreIcon from "@material-ui/icons/LocalGroceryStore";
import LoadingOverlay from "react-loading-overlay";

import "./styles.css";

LoadingOverlay.propTypes = undefined

const coreUrl = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;

class SuccessOrderPolling extends Component {
  state = {
    pollingCount: 0,
    accessToken: "",
    delay: 3000,
    loaded: false,
    order: {
      price_detail: {
        total: null
      }
    }
  }

    async getAccessToken() {
    const response = await TokenService.getProperty(Property.getData().uid)
    const accessToken = response.data
    Property.setPollingAccessToken(accessToken.access_token)
  }

  async componentDidMount() {
    window.scrollTo(0, 0)
    const { match } = this.props;
    if (match.url === "/success_polling") {
      window.history.pushState(null, document.title, window.location.href);
      window.addEventListener('popstate', () => {
        window.history.pushState(null, document.title, window.location.href);
        this.setState({ errorModalStatus: true });
      });
    }

    await this.getAccessToken();
    this.fulfillmentcheck.bind(this);
    await this.fulfillmentcheck();
  }


  fulfillmentcheck = async () => {
    if (this.loaded) return;

    let info = Property.getOrderInfo();
    let paymentTx = Property.getPaymentTransaction()
    var self = this;

    await axios({
      method: "GET",
      url: `${coreUrl}/payment_transactions/${paymentTx.reference}/fulfillmentcheck?type=${info.type}&uid=${info.uid}&store_shopping_cart_id=${paymentTx.store_shopping_cart_id}`,
      headers: { Authorization: `Bearer ${Property.getPollingAccessToken()}` },
    }).then(async function (result) {
      self.setState({loaded: true, order: result.data})
    })
  }

  render() {
    const preset = Property.getPreset();
    const currencyCode = Property.getCurrencyCode();

    return (
      <LoadingOverlay
        active={!this.state.loaded}
        spinner
        text='Loading...'
      >
        <div>
          <Container>
            {
              this.state.errorModalStatus ?
                <ErrorModal
                  stateModal={this.state.errorModalStatus}
                  openCloseModal={(modalStatus) => this.setState({ errorModalStatus: modalStatus })}
                  textTitle={this.props.t('WARNING')} btnErrorText={this.props.t('OK')}
                  childText={this.props.t('TRANSACTION_COMPLETE')}
                />
                : null
            }
            <Flex container flex={1} margin="15px" alignItems="center" justifyContent="space-between">
              <TitleOrder className={'finishTitle'} app_home_color_primary={preset.app_home_color_primary}>
                <LocalGroceryStoreIcon fontSize="large" style={{ verticalAlign: 'text-top' }} />{this.props.t('HOTEL_STORE')}
              </TitleOrder>
              <TitleOrder className={'finishTitle'} app_home_color_primary={preset.app_home_color_primary}>
                {Intl.NumberFormat(currencyCode, {
                  style: "currency",
                  currency: currencyCode,
                  currencyDisplay: "code",
                }).format(get(this.state.order, "price_detail.total", 0))}
              </TitleOrder>
            </Flex>
            <hr />
            <Flex container flex={1} margin="15px" alignItems="center" justifyContent="space-between">
              <Subtotal fontSize="12px" color="gray"  >{this.props.t('ASSIGNED_TO')}</Subtotal>
            </Flex>
            <Flex container flex={1} margin="15px" alignItems="center" justifyContent="space-between">
              <Flex container alignItems="center">
                <Avatar src={get(this.state.order, 'staff_detail.avatar')} />
                <Flex margin="0 0 0 5px">
                  <TitleName>{get(this.state.order, 'staff_detail.full_name')}</TitleName>
                  <Detail>{get(this.state.order, 'staff_detail.role')}</Detail>
                </Flex>
              </Flex>
              <Flex>
                <Status>{this.props.t('STATUS')}</Status>
                <StatusValue app_home_color_primary={preset.app_home_color_primary}>
                  {get(this.state.order, 'status')}
                </StatusValue>
              </Flex>
            </Flex>
            <Flex container flex={1} margin="15px" alignItems="center" justifyContent="space-between">
              <Detail>{`${this.props.t('CREATED')}: ${moment(get(this.state.order, 'created_at')).format("h:mma L")}`}</Detail>
            </Flex>
            <hr />
            {get(this.state.order, 'products', []).map((product, i) => (
              <Flex container flex={1} margin="15px" justifyContent="space-between" key={i}>
                <Flex container flex={1}>
                  <Detail>{product.quantity}x</Detail>
                  <Flex margin="0 0 0 5px">
                    <div>{product.title}</div>
                    <ProductOption>{product.options}</ProductOption>
                  </Flex>
                </Flex>
                <div>
                  {Intl.NumberFormat(currencyCode, {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "code",
                  }).format(product.total)}
                </div>
              </Flex>
            ))}
            <hr />
            <Flex margin="15px" alignItems="center" justifyContent="space-between">
              <Flex container justifyContent="space-between" margin="2px 0">
                <Subtotal>{this.props.t('SUBTOTAL')}</Subtotal>
                <Subtotal>
                  {Intl.NumberFormat(currencyCode, {
                    style: "currency",
                    currency: currencyCode,
                    currencyDisplay: "code",
                  }).format(get(this.state.order, 'price_detail.subtotal', 0))}
                </Subtotal>
              </Flex>
              {get(this.state.order, 'price_detail.extra_charges', []) &&
                get(this.state.order, 'price_detail.extra_charges', []).map((extraCharge, i) => (
                  <Flex container justifyContent="space-between" margin="2px 0" key={i}>
                    <Subtotal>{extraCharge.title}{extraCharge.type === "percent" ? ` (${extraCharge.value}%)` : ``}</Subtotal>
                    <Subtotal>
                      {Intl.NumberFormat(currencyCode, {
                        style: "currency",
                        currency: currencyCode,
                        currencyDisplay: "code",
                      }).format(extraCharge.amount)}
                    </Subtotal>
                  </Flex>
                ))
              }
              {get(this.state.order, 'price_detail.last_extra_charges', []) &&
                get(this.state.order, 'price_detail.last_extra_charges', []).map((lastExtraCharge, i) => (
                  <Flex container justifyContent="space-between" margin="2px 0" key={i}>
                    <Subtotal>{lastExtraCharge.title}{lastExtraCharge.type === "percent" ? ` (${lastExtraCharge.value}%)` : ``}</Subtotal>
                    <Subtotal>
                      {Intl.NumberFormat(currencyCode, {
                        style: "currency",
                        currency: currencyCode,
                        currencyDisplay: "code",
                      }).format(lastExtraCharge.amount)}
                    </Subtotal>
                  </Flex>
                ))
              }
            </Flex>
            <hr />
            <Flex container flex={1} margin="15px" alignItems="center" justifyContent="space-between">
              <Total>{this.props.t('TOTAL')}</Total>
              <Total>
                {Intl.NumberFormat(currencyCode, {
                  style: "currency",
                  currency: currencyCode,
                  currencyDisplay: "code",
                }).format(get(this.state.order, 'price_detail.total', 0))}
              </Total>
            </Flex>
            <Flex container flex={1} margin="15px" alignItems="center" justifyContent="center">
              <Notes>{get(this.state.order, 'notes', '')}</Notes>
            </Flex>
            <Flex container flex={1} margin="15px" alignItems="center" justifyContent="center">
              {isEmpty(Property.getStore().call_to_action_link) ?
                null :
                <Link fontSize={'20px'} disabled={this.state.edit} href={Property.getStore().call_to_action_link} label={Property.getStore().call_to_action_text} backgroundColor={preset.app_home_color_primary} borderRadius={"30px"} color={preset.text_color}></Link>
              }
            </Flex>
          </Container>
        </div>
      </LoadingOverlay>
    )
  }
}

export default withTranslation()(SuccessOrderPolling);
